module.exports = __webpack_public_path__ + "img/penta5classic_icon.b34d94c2.png";